import { checkUserToken } from '../lib/OidcHelper';
import { deleteRemoteFave, setRemoteFaves } from '../lib/ApiHubHelper';
import { hideMessageboxModal, showMessageboxModal } from "./TripPlannerHelper";


// initFavButton is called from a number of places including SearchSubmit.js when search results change.
function initFavButton() {

  const favButtonsExist = (!!$('.product-card__fav-btn') && $('.product-card__fav-btn').length > 0);

  if (favButtonsExist) {
    $('.product-card__fav-btn').off('click'); // remove any existing listeners.
    $('.product-card__fav-btn').on('click', onClickFav.bind(this));
    checkFaves();
  }
}

function onClickFav(event) {
  console.log('clicked a Fave.');
  let current = event.currentTarget;
  //console.log('current:', current);

  let parent = current.closest('.product-card__area') || current.closest('.product-card__fav');
  // console.log('parent:', parent);
  let productid = parent.getAttribute('productid');

  // Show modal if not logged in
  if (!isLoggedIn()) {
    showMessageboxModal('#msgboxModalUpsell');
    return;
  }

  // check if product is faved before adding or removing product.
  if (checkProductFav(productid)) {
    console.log('remove fav');
    remoteRemoveProduct(productid); // remove product to remote if logged in.
    localRemoveProduct(productid);
  } else {
    console.log('add fav');
    remoteAddProduct(productid); // add product to remote if logged in.
    localAddProduct(productid);
  }
}

function checkProductFav(productid) {
  let result = false;

  // Fave buttons can appear on product pgs or any product cards.
  let selectors = [
    `.product-card__area[productid="${productid}"] .product-card__fav-btn--active`,
    `.product-card__fav[productid="${productid}"] .product-card__fav-btn--active`
  ]

  selectors.forEach(el => {
    let favEl = document.querySelector(el);
    // console.log('favEl:', favEl);
    if (!!favEl) {
      result = true;
    }
  });
  return result;

}

function localStorageGetFaves() { // returns faves array.
  const store = window.localStorage;
  //console.log("localStorageGetFaves", store);
  return JSON.parse(store.getItem('favourites')) || [];
}

function localAddProduct(productid) {
  let faves = localStorageGetFaves();
  if (faves.includes(productid)) { // check if already in store
    return;
  }
  faves.push(productid);
  const store = window.localStorage;
  store.setItem('favourites', JSON.stringify(faves));
  markFav(productid);
}

function localRemoveProduct(productid) {
  let faves = localStorageGetFaves();
  faves = faves.filter(item => item !== productid); // remove item from array
  const store = window.localStorage;
  store.setItem('favourites', JSON.stringify(faves));
  unmarkFav(productid);
}

function remoteAddProduct(productId) {

  console.log('in remoteAddProduct ');

  const token = checkUserToken(); // from OidcHelper.js

  // if logged in and have token
  // add productId to server via API
  if (!!token) {
    console.log('add to remote.');
    setRemoteFaves(token, productId);
  }
  if (!token) {
    console.log('No token. No add to remote.');
    prefCentreIsLoggedOut();
  }

}

function isLoggedIn() {
  const token = checkUserToken(); // from OidcHelper.js

  return !!token;
}

async function remoteRemoveProduct(productId) {

  const token = checkUserToken(); // from OidcHelper.js

  // console.log('remove DDDD token:', token);

  // if logged in and have token
  // remove productId from server via API
  if (!!token) {
    // console.log('remove from remote.');
    await deleteRemoteFave(token, productId);
  }
  if (!token) {
    // console.log('No token. No remove from remote.');
    prefCentreIsLoggedOut();
  }

}

function checkFaves() {
  // console.log("faves", "loaded");
  const faves = localStorageGetFaves();

  if (faves.length < 0) {
    return;
  }

  faves.forEach(id => {
    markFav(id);
  });
}

function markFav(productid) {
  //console.log('markFav', productid);
  let favEl = $(`.product-card__area[productid="${productid}"] .product-card__fav-btn`);
  if (favEl.length < 1) {
    favEl = $(`.product-card__fav[productid="${productid}"] .product-card__fav-btn`);
    //console.log("favEL-1", favEl);
  }
  favEl.addClass('product-card__fav-btn--active');
}

function unmarkFav(productid) {
  let favEl = $(`.product-card__area[productid="${productid}"] .product-card__fav-btn`);
  if (favEl.length < 1) {
    favEl = $(`.product-card__fav[productid="${productid}"] .product-card__fav-btn`);
  }
  favEl.removeClass('product-card__fav-btn--active');
}

function prefCentreIsLoggedOut() {
  // Shift the page to a logged out state.
  console.log('prefCentreIsLoggedOut cleanup');
  const store = window.localStorage;
  // delete old token and expiry
  store.removeItem('user_token');
  store.removeItem('user_expires_at');
  // if pref-centre page change panel to faves
  // if any other page? reload page once?
}

export { initFavButton, onClickFav, checkProductFav, localAddProduct, localStorageGetFaves, checkFaves };
